export default __webpack_public_path__ + "static/media/home-cafe-slider-img02.fdac802d.jpg";